import {ObjectUtils} from "./object-utils";
import {diacriticsMap} from "../../storage/models/string-accent-map";

export class StringUtils {
  static isBlankOrNull(s: string): boolean {
    if (!s) return true;
    if (typeof s === 'object') return ObjectUtils.isNilOrEmptyObject(s);
    return ObjectUtils.isNil(s.trim()) || !s.trim();
  }

  static unaccent(s: string): string {
    return s.replace(/[^\u0000-\u007E]/g, function (a) {
      return diacriticsMap[a] || a;
    });
  }

  static kebabCase(s: string) {
    return s.toString().replace(/([A-Z])([A-Z])/g, '$1-$2')
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase();
  }

}
